import {FC} from 'react'
import {Link} from 'react-router-dom'

interface EmployeeNameProps {
  employee: {
    id: string
    staffCode: string
    displayFullName: string
  }
}

export const EmployeeName: FC<EmployeeNameProps> = ({employee}) =>
  employee ? (
    <div className="m-title-main-name">
      <Link to={`/employees/${employee.id}`} target="_blank">
        <span>スタッフコード：{employee.staffCode}</span>
        <span className="u-pl20">従業員名：{employee.displayFullName}</span>
      </Link>
    </div>
  ) : (
    <></>
  )
